import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutRight"><Path d="M17 21H3V3H17V21Z" fill="currentColor"/><Path d="M21 21H19.5V3H21V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutRight;
